import React, { useState } from "react";
import axios from "axios";
import {
  Container,
  Grid,
  Box,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import ForumIcon from "@mui/icons-material/Forum";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import contactus from "../Assests/Images/contactus.jpeg";
import contactusside from "../Assests/Images/contactusside.png";
import API_BASE_URL from "../../src/config";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    mail: "",
    message: "",
  });
  const [responseMessage, setResponseMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/contactus`,
        formData
      );
      setResponseMessage("Message sent successfully!");
      setFormData({ name: "", mail: "", message: "" });
    } catch (err) {
      setResponseMessage("Failed to send message. Please try again.");
    }
  };

  return (
    <>
      {/* Full-Screen Width Top Image Section */}
      <Box sx={{ width: "98.8vw", height: "60vh", position: "relative", overflow: "hidden" }}>
        <img
          src={contactus}
          alt="Contact"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: "25%",
            left: "45%",
            color: "#42326e",
            fontWeight: "bold",
            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.7)",
            fontSize: "7.5rem",
            pointerEvents: "none",
          }}
        >
          Contact Us
        </Box>
      </Box>

      {/* Content Container */}
      <Container maxWidth="lg" sx={{ mb: 5 }}>
        {/* 4 Info Boxes */}
        <Grid container spacing={2} sx={{ marginTop: 4 }}>
          <Grid item xs={6} sm={3}>
            <Box
              sx={{
                height: "150px",
                backgroundColor: "#c6bbdf",
                borderRadius: "15px 50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: 3,
                textAlign: "center",
                padding: 2,
              }}
            >
              <LocationOnIcon sx={{ fontSize: 40, color: "black" }} />
              <Typography variant="h6" sx={{ marginTop: 1, color: "black" }}>
                Location
              </Typography>
              <Typography variant="body2" sx={{ marginTop: 1, color: "black" }}>
                Flat No 212, Bhoomatha Thalluri Heights, Kankipadu, Krishna
                District, Vijayawada - 521151, Andhra Pradesh, India.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Box
              sx={{
                height: "150px",
                backgroundColor: "#c6bbdf",
                borderRadius: "15px 50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: 3,
                textAlign: "center",
                padding: 2,
              }}
            >
              <EmailIcon sx={{ fontSize: 40, color: "black" }} />
              <Typography variant="h6" sx={{ marginTop: 1, color: "black" }}>
                Email
              </Typography>
              <Typography variant="body2" sx={{ marginTop: 1, color: "black" }}>
                contact@cityzoom.in
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Box
              sx={{
                height: "150px",
                backgroundColor: "#c6bbdf",
                borderRadius: "15px 50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: 3,
                textAlign: "center",
                padding: 2,
              }}
            >
              <PhoneIcon sx={{ fontSize: 40, color: "black" }} />
              <Typography variant="h6" sx={{ marginTop: 1, color: "black" }}>
                Phone
              </Typography>
              <Typography variant="body2" sx={{ marginTop: 1, color: "black" }}>
              +91 9550768953
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Box
              sx={{
                height: "150px",
                backgroundColor: "#c6bbdf",
                borderRadius: "15px 50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: 3,
                textAlign: "center",
                padding: 2,
              }}
            >
              <ForumIcon sx={{ fontSize: 40, color: "black" }} />
              <Typography variant="h6" sx={{ marginTop: 1, color: "black" }}>
                Live Chat
              </Typography>
              <Typography variant="body2" sx={{ marginTop: 1, color: "black" }}>
                Chat with us online
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Contact Form and Map/Image */}
        <Grid container spacing={4} sx={{ marginTop: 4, marginBottom: "20px" }}>
          {/* Left Column - Form */}
          <Grid item xs={12} md={6}>
            <Typography variant="h5" gutterBottom sx={{ color: "#42326e", fontSize:"1.7rem",fontWeight:"bold" }}>
              Get In Touch
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                padding: 3,
                borderRadius: 2,
                boxShadow: `1px 1px 2px 2px #b6a6d1`,
              }}
            >
              <TextField
                name="name"
                label="Name"
                fullWidth
                value={formData.name}
                onChange={handleChange}
                InputProps={{ sx: { backgroundColor: "#d6d1ec" } }}
              />
              <TextField
                name="mail"
                label="Email"
                fullWidth
                value={formData.mail}
                onChange={handleChange}
                InputProps={{ sx: { backgroundColor: "#d6d1ec" } }}
              />
              <TextField
                name="message"
                label="Message"
                multiline
                rows={4}
                fullWidth
                value={formData.message}
                onChange={handleChange}
                InputProps={{ sx: { backgroundColor: "#d6d1ec" } }}
              />
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    backgroundColor: "#42326e",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "black",
                      color: "white",
                    },
                  }}
                >
                  Submit
                </Button>
              </Box>
              {responseMessage && (
                <Typography sx={{ color: "#42326e", mt: 2 }}>
                  {responseMessage}
                </Typography>
              )}
            </Box>
          </Grid>

          {/* Right Column - Google Map or Image */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                height: "410px",
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: 2,
              }}
            >
              <img
                src={contactusside}
                alt="Banner"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Contact;
